import React, { forwardRef, useImperativeHandle, useState } from "react";
import BasicBaseImport from "../BasicImport/BasicBaseImport";

const BasicBaseImportModal = forwardRef(({ importData, apiURL }, ref) => {
  const [show, setShow] = useState(false);
  useImperativeHandle(ref, () => ({
    open: () => {
      setShow(true);
    },
    close: () => {
      setShow(false);
    },
  }));

  return (
    <BasicBaseImport
      setShow={setShow}
      show={show}
      api={apiURL}
      shouldUniqueColumn={importData.shouldUniqueColumn}
      shouldExistColumns={importData.shouldExistColumns}
      shouldBeUniqueCompositeColumns={importData.shouldBeUniqueCompositeColumns}
      nullableColumns={importData.nullableColumns}
      columns={importData.columns}
      dataName={importData.dataName}
      enableAddMode={importData.enableAddMode}
    />
  );
});

export default BasicBaseImportModal;
